export enum UserDefinitionFilterPatternKinds {
  And,
  Or,
}
